// Home page JS Here
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // ScrollTrigger.create({
  //   start: "top top",
  //   end: 99999,
  //   onUpdate: (self) => {
  //     const header = document.querySelector(".site-header");
  //     // self.direction === -1 ? showAnim.play() : showAnim.reverse();
  //     if (self.direction === 1) {
  //       gsap.to(header, {
  //         yPercent: -100,
  //         duration: 0.3,
  //         ease: "none",
  //         onComplete: () => {
  //           header.classList.remove("stuck");
  //         },
  //       });
  //     } else {
  //       if (
  //         window.scrollY > window.innerHeight &&
  //         !header?.classList.contains("stuck")
  //       ) {
  //         gsap.fromTo(
  //           header,
  //           { yPercent: -100 },
  //           { yPercent: 0, duration: 0.3, ease: "none" }
  //         );
  //         header?.classList.add("stuck");
  //       } else if (window.scrollY <= window.innerHeight) {
  //         // header.classList.remove('stuck');
  //         gsap.to(header, {
  //           yPercent: -100,
  //           duration: 0.3,
  //           ease: "none",
  //           onComplete: () => {
  //             header.classList.remove("stuck");
  //           },
  //         });
  //       }
  //     }
  //   },
  // });

  // hide/show menu based on scroll
  const header = document.querySelector(".site-header");
  const showAnim = gsap
    .from(header, {
      yPercent: -100,
      paused: true,
      duration: 0.5,
      ease: "power2",
    })
    .progress(1);

  ScrollTrigger.create({
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
      if (self.direction === -1 && window.scrollY > window.innerHeight) {
        header.classList.add("solid");
        showAnim.play();
      } else if (
        self.direction === -1 &&
        window.scrollY < window.innerHeight / 2 &&
        self.progress === 0
      ) {
        header.classList.remove("solid");
        showAnim.play();
      } else {
        showAnim.reverse();
      }
    },
  });
});
